'use client';
import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'react-share';
import toast from 'react-hot-toast';
import { CheckCircle } from '@phosphor-icons/react';
export default function SocialShare() {
  const pathname = usePathname();
  const [fullURL, setFullURL] = useState('');

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (window && window.location) {
      const { protocol, hostname, port } = window.location;
      const host = port ? `${hostname}:${port}` : hostname;
      setFullURL(`${protocol}//${host}${pathname}`);
    }
  }, [pathname]);

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(fullURL);
      console.log('Text copied to clipboard:', fullURL);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (error) {
      console.error('Error copying text:', error);
      toast.error('There was an error copying the link', {
        position: 'bottom-center',
      });
    }
  }

  return (
    <>
      <div className='flex gap-3 pt-10 md:p-0'>
        <FacebookShareButton url={fullURL}>
          <div className='flex h-9 w-9 items-center justify-center rounded-full border border-gray-300 hover:border-gray-400 hover:bg-gray-200 hover:[&_svg]:opacity-90'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='9'
              height='15'
              viewBox='0 0 9 15'
              fill='none'
            >
              <path
                d='M5.49284 14.3466V7.89857H7.64266L7.96513 5.38785H5.49284V3.7852C5.49284 3.05735 5.69405 2.56241 6.73312 2.56241H8.05471V0.316479C7.4139 0.247734 6.76982 0.214411 6.12538 0.216659C4.22087 0.216659 2.91583 1.38676 2.91583 3.53564V5.38785H0.760498V7.89857H2.9172V14.3466H5.49284Z'
                fill='#121212'
              />
            </svg>
          </div>
        </FacebookShareButton>

        <TwitterShareButton url={fullURL}>
          <div className='flex h-9 w-9 items-center justify-center rounded-full border border-gray-300 hover:border-gray-400 hover:bg-gray-200 hover:[&_svg]:opacity-90'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='15'
              viewBox='0 0 14 15'
              fill='none'
            >
              <path
                d='M8.54435 6.24153L13.4859 0.48999H12.3149L8.02416 5.48397L4.59714 0.48999H0.64447L5.8268 8.04177L0.64447 14.0731H1.81553L6.34669 8.79933L9.96588 14.0731H13.9186L8.54406 6.24153H8.54435ZM6.94042 8.10831L6.41534 7.35632L2.23748 1.37268H4.03616L7.40775 6.20167L7.93283 6.95366L12.3155 13.2306H10.5168L6.94042 8.1086V8.10831Z'
                fill='#1D1D1B'
              />
            </svg>
          </div>
        </TwitterShareButton>

        <LinkedinShareButton url={fullURL}>
          <div className='flex h-9 w-9 items-center justify-center rounded-full border border-gray-300 hover:border-gray-400 hover:bg-gray-200 hover:[&_svg]:opacity-90'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
            >
              <g clipPath='url(#clip0_324_5767)'>
                <path
                  d='M6.33376 8.14453H3.69592V16.6589H6.33376V8.14453Z'
                  fill='#1D1D1B'
                />
                <path
                  d='M5.00585 7.02733C5.31754 7.02939 5.62282 6.93884 5.88298 6.76717C6.14315 6.5955 6.34648 6.35046 6.46719 6.06308C6.5879 5.7757 6.62056 5.45895 6.56102 5.15299C6.50148 4.84703 6.35241 4.56565 6.13273 4.34452C5.91306 4.12339 5.63268 3.97246 5.32712 3.91089C5.02156 3.84932 4.70461 3.87989 4.41644 3.99869C4.12827 4.11749 3.88186 4.31919 3.70847 4.57821C3.53508 4.83723 3.44251 5.1419 3.4425 5.4536C3.4425 5.86919 3.60688 6.2679 3.89977 6.56273C4.19266 6.85757 4.59027 7.02458 5.00585 7.02733Z'
                  fill='#1D1D1B'
                />
                <path
                  d='M10.549 12.1856C10.549 10.9854 11.0858 10.2734 12.1603 10.2734C13.1276 10.2734 13.5948 10.9558 13.5948 12.1856V16.6547H16.2215V11.2831C16.2215 8.99968 14.9269 7.89877 13.122 7.89877C12.6088 7.8911 12.1025 8.01677 11.6524 8.26345C11.2024 8.51013 10.8241 8.86938 10.5545 9.3061V8.1548H8.04553V16.6748H10.5753L10.549 12.1856Z'
                  fill='#1D1D1B'
                />
              </g>
              <defs>
                <clipPath id='clip0_324_5767'>
                  <rect
                    width='19.2017'
                    height='19.2017'
                    fill='white'
                    transform='translate(0.243713 0.680664)'
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </LinkedinShareButton>

        <div
          onClick={() => copyToClipboard()}
          className='flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-gray-300 hover:border-gray-400 hover:bg-gray-200 hover:[&_svg]:opacity-90'
        >
          {!copied ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
            >
              <path
                d='M7.32297 11.9229C7.3901 11.9898 7.44336 12.0693 7.4797 12.1568C7.51605 12.2444 7.53475 12.3382 7.53475 12.433C7.53475 12.5277 7.51605 12.6216 7.4797 12.7091C7.44336 12.7966 7.3901 12.8761 7.32297 12.943L7.01574 13.2502C6.68961 13.5776 6.30182 13.837 5.8748 14.0136C5.44778 14.1901 4.98999 14.2802 4.52792 14.2787C3.83206 14.279 3.15176 14.0728 2.5731 13.6863C1.99444 13.2998 1.54342 12.7503 1.2771 12.1075C1.01077 11.4646 0.941111 10.7572 1.07693 10.0747C1.21275 9.3922 1.54794 8.76534 2.0401 8.2734L4.12528 6.18822C4.5688 5.74476 5.12279 5.42791 5.72989 5.27047C6.337 5.11302 6.97515 5.12071 7.57828 5.29273C8.18142 5.46475 8.72761 5.79484 9.16033 6.24885C9.59304 6.70286 9.89654 7.26427 10.0394 7.87497C10.0631 7.96782 10.068 8.06446 10.0538 8.15923C10.0396 8.254 10.0067 8.34499 9.95691 8.42686C9.90713 8.50874 9.84151 8.57985 9.76389 8.63604C9.68627 8.69223 9.59822 8.73237 9.50489 8.75409C9.41157 8.77581 9.31484 8.77869 9.22039 8.76256C9.12594 8.74642 9.03566 8.7116 8.95483 8.66012C8.87401 8.60865 8.80428 8.54156 8.74971 8.46279C8.69515 8.38402 8.65686 8.29515 8.63708 8.2014C8.55231 7.8409 8.37278 7.50959 8.11707 7.24172C7.86137 6.97385 7.53875 6.77913 7.18259 6.6777C6.82642 6.57627 6.44963 6.57181 6.09116 6.66477C5.73269 6.75774 5.40555 6.94476 5.14357 7.20651L3.05839 9.29169C2.76773 9.58212 2.56972 9.95221 2.48941 10.3552C2.4091 10.7581 2.45009 11.1759 2.60719 11.5555C2.7643 11.9352 3.03047 12.2597 3.37204 12.4881C3.71361 12.7165 4.11523 12.8385 4.52612 12.8386C4.79913 12.8394 5.06958 12.786 5.32182 12.6816C5.57407 12.5771 5.80309 12.4237 5.99565 12.2302L6.30228 11.9229C6.36918 11.8557 6.44871 11.8024 6.53629 11.766C6.62387 11.7296 6.71778 11.7108 6.81262 11.7108C6.90746 11.7108 7.00137 11.7296 7.08895 11.766C7.17653 11.8024 7.25606 11.8557 7.32297 11.9229ZM13.9026 3.30796C13.2426 2.64821 12.3476 2.27759 11.4144 2.27759C10.4813 2.27759 9.58628 2.64821 8.92631 3.30796L8.61968 3.61459C8.48441 3.74986 8.40841 3.93333 8.40841 4.12463C8.40841 4.31594 8.48441 4.49941 8.61968 4.63468C8.75495 4.76995 8.93842 4.84595 9.12973 4.84595C9.32103 4.84595 9.5045 4.76995 9.63977 4.63468L9.947 4.32745C10.3369 3.93755 10.8657 3.7185 11.4171 3.7185C11.9685 3.7185 12.4974 3.93755 12.8873 4.32745C13.2772 4.71735 13.4962 5.24618 13.4962 5.79758C13.4962 6.34899 13.2772 6.87781 12.8873 7.26771L10.7985 9.3499C10.606 9.54349 10.3769 9.69695 10.1247 9.80139C9.87243 9.90584 9.60196 9.95919 9.32895 9.95835C8.8606 9.95802 8.4061 9.79948 8.03916 9.50845C7.67221 9.21743 7.41434 8.81097 7.30737 8.35501C7.26408 8.16897 7.14866 8.00775 6.9865 7.9068C6.82434 7.80586 6.62873 7.77347 6.44269 7.81676C6.25665 7.86005 6.09543 7.97547 5.99448 8.13762C5.89354 8.29978 5.86115 8.4954 5.90444 8.68144C6.08512 9.45363 6.52136 10.1421 7.14241 10.6353C7.76346 11.1285 8.5329 11.3974 9.32594 11.3985H9.32895C9.79123 11.3997 10.2492 11.3093 10.6763 11.1325C11.1034 10.9556 11.4913 10.6959 11.8174 10.3682L13.9026 8.283C14.2293 7.95636 14.4884 7.56856 14.6652 7.14175C14.8421 6.71493 14.9331 6.25747 14.9331 5.79548C14.9331 5.33349 14.8421 4.87603 14.6652 4.44922C14.4884 4.0224 14.2293 3.6346 13.9026 3.30796Z'
                fill='black'
              />
            </svg>
          ) : (
            <CheckCircle className='text-3xl font-bold text-black' />
          )}
        </div>
      </div>
    </>
  );
}
